import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { projectsKeys } from './projects.key';
import { toast } from '../../../components/Toast';
import { toastExistingCompletedCheck } from '../../../components/Toast/toastExistingCompletedCheck';

type OrderResponse = {
  existingCompletedCheckCreatedAt?: string | null;
};

export function useOrderBackgroundControl(
  companyId: string,
  projectId: string
) {
  const getApi = useApi();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async () => {
      const api = await getApi();
      const res = await api.backgroundControlsOrderOrder({
        companyId,
        projectId,
      });
      return res.data as unknown as OrderResponse;
    },
    onError: () => toast.error('Något gick fel'),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: projectsKeys.all });
      toast.success('Bakgrundskontroll beställd');
      toastExistingCompletedCheck(data?.existingCompletedCheckCreatedAt);
    },
  });

  return mutation;
}
